import "./Intro.css";
import { useLanguage } from "../LanguageContext";
const HardwareProducts = () => {
  const { language } = useLanguage();

  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading">
          <span>
            {language === "en"
              ? "Hardware Products"
              : "ฮาร์ดแวร์สำหรับองค์กร (Hardware Products)"}
          </span>
        </h2>
        <p className="description">
          {language === "en" ? (
            <>
              As a trusted system integrator, Proscope offers a wide range of
              enterprise, commercial, and consumer-grade hardware solutions. We
              partner with leading global vendors to deliver high-performance,
              reliable systems tailored to each customer’s unique infrastructure
              needs.
              <br />
              <br />
            </>
          ) : (
            <>
              ในฐานะผู้ให้บริการระบบแบบครบวงจร (System Integrator) Proscope
              นำเสนออุปกรณ์ฮาร์ดแวร์ระดับองค์กร ทั้งในกลุ่ม Enterprise,
              Commercial และ Consumer จากผู้ผลิตชั้นนำระดับโลก
              เราคัดสรรผลิตภัณฑ์ที่มีความเสถียร
              รองรับการใช้งานในองค์กรได้อย่างมั่นใจ
              พร้อมปรับให้ตรงกับความต้องการเฉพาะของแต่ละธุรกิจ
              <br />
              <br />
            </>
          )}
        </p>

        <p className="description">
          {language === "en"
            ? `
          Our certified engineering and consulting teams work closely with
          clients to recommend, implement, and support the right hardware for
          each project — from core infrastructure to endpoint devices.`
            : `ทีมวิศวกรและที่ปรึกษาของเรา พร้อมให้บริการตั้งแต่การแนะนำผลิตภัณฑ์ การวางแผน ไปจนถึงการติดตั้งและสนับสนุนหลังการใช้งาน เพื่อให้ได้ระบบที่เหมาะสมที่สุด ทั้งในส่วนโครงสร้างพื้นฐาน (Core Infrastructure) และอุปกรณ์ปลายทาง (Endpoint)`}
        </p>
        <p className="description">
          {language === "en" ? (
            <>
              <br />
              If you're looking for something specific and can't find it among
              these brands, please don’t hesitate to contact us. We're happy to
              help identify and provide alternative or emerging solutions
              tailored to your needs.
            </>
          ) : (
            <>
              <br />
              หากคุณไม่พบแบรนด์หรือผลิตภัณฑ์ที่ต้องการ กรุณาติดต่อเรา — <br />
              <strong>
                เราพร้อมช่วยค้นหาและแนะนำทางเลือกที่เหมาะสมกับองค์กรของคุณ
              </strong>
            </>
          )}
        </p>
        <div className="horizontal-text-container">
          <p>Products</p>
          <p>/</p>
          <p>Hardware Products</p>
        </div>
      </div>
    </div>
  );
};

export default HardwareProducts;
